module.exports = __webpack_public_path__ + "img/representation-experimentation.844b1e32.jpg";